var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimpleHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_278",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 61
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 60,
    height: 60,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_278)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.0001,
    cy: 15.5,
    r: 3.62069,
    fill: "#FDE047"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.0001,
    cy: 45.5,
    r: 3.62069,
    fill: "#FDE047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 53C19.75 53 17.3958 52.0208 15.4375 50.0625C13.4792 48.1042 12.5 45.75 12.5 43V22.5625C11.0417 22.0208 9.84375 21.1146 8.90625 19.8438C7.96875 18.5729 7.5 17.125 7.5 15.5C7.5 13.4167 8.22917 11.6458 9.6875 10.1875C11.1458 8.72917 12.9167 8 15 8C17.0833 8 18.8542 8.72917 20.3125 10.1875C21.7708 11.6458 22.5 13.4167 22.5 15.5C22.5 17.125 22.0312 18.5729 21.0938 19.8438C20.1562 21.1146 18.9583 22.0208 17.5 22.5625V43C17.5 44.375 17.9896 45.5521 18.9688 46.5312C19.9479 47.5104 21.125 48 22.5 48C23.875 48 25.0521 47.5104 26.0312 46.5312C27.0104 45.5521 27.5 44.375 27.5 43V18C27.5 15.25 28.4792 12.8958 30.4375 10.9375C32.3958 8.97917 34.75 8 37.5 8C40.25 8 42.6042 8.97917 44.5625 10.9375C46.5208 12.8958 47.5 15.25 47.5 18V38.4375C48.9583 38.9792 50.1562 39.8854 51.0938 41.1562C52.0312 42.4271 52.5 43.875 52.5 45.5C52.5 47.5833 51.7708 49.3542 50.3125 50.8125C48.8542 52.2708 47.0833 53 45 53C42.9167 53 41.1458 52.2708 39.6875 50.8125C38.2292 49.3542 37.5 47.5833 37.5 45.5C37.5 43.875 37.9688 42.4167 38.9062 41.125C39.8438 39.8333 41.0417 38.9375 42.5 38.4375V18C42.5 16.625 42.0104 15.4479 41.0312 14.4688C40.0521 13.4896 38.875 13 37.5 13C36.125 13 34.9479 13.4896 33.9688 14.4688C32.9896 15.4479 32.5 16.625 32.5 18V43C32.5 45.75 31.5208 48.1042 29.5625 50.0625C27.6042 52.0208 25.25 53 22.5 53ZM15 18C15.7083 18 16.3021 17.7604 16.7812 17.2812C17.2604 16.8021 17.5 16.2083 17.5 15.5C17.5 14.7917 17.2604 14.1979 16.7812 13.7188C16.3021 13.2396 15.7083 13 15 13C14.2917 13 13.6979 13.2396 13.2188 13.7188C12.7396 14.1979 12.5 14.7917 12.5 15.5C12.5 16.2083 12.7396 16.8021 13.2188 17.2812C13.6979 17.7604 14.2917 18 15 18ZM45 48C45.7083 48 46.3021 47.7604 46.7812 47.2812C47.2604 46.8021 47.5 46.2083 47.5 45.5C47.5 44.7917 47.2604 44.1979 46.7812 43.7188C46.3021 43.2396 45.7083 43 45 43C44.2917 43 43.6979 43.2396 43.2188 43.7188C42.7396 44.1979 42.5 44.7917 42.5 45.5C42.5 46.2083 42.7396 46.8021 43.2188 47.2812C43.6979 47.7604 44.2917 48 45 48Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleHover);
export default __webpack_public_path__ + "static/media/simple-hover.3a07c470d3dae97da962d8ffb54b58a1.svg";
export { ForwardRef as ReactComponent };